/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AssignmentReferencesCountsDto } from './assignment-references-counts-dto';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface AssignmentReferencesDto
 */
export interface AssignmentReferencesDto {

    /**
     * The assignment these references describe
     *
     * @type {JoinEntityDto}
     * @memberof AssignmentReferencesDto
     */
    assignment: JoinEntityDto;

    /**
     * The member the assignment belongs to, for linking
     *
     * @type {JoinEntityDto}
     * @memberof AssignmentReferencesDto
     */
    member: JoinEntityDto;

    /**
     * Current status of the assignment itself
     *
     * @type {string}
     * @memberof AssignmentReferencesDto
     */
    status: AssignmentReferencesDtoStatusEnum;

    /**
     * Whether deleting needs `?confirm=true`. False only while the therapy is still entirely SCHEDULED, where there is nothing to acknowledge.
     *
     * @type {boolean}
     * @memberof AssignmentReferencesDto
     */
    requiresConfirmation: boolean;

    /**
     * Whether deleting is refused no matter what, because a session is being performed right now. Transient — it clears when that session resolves.
     *
     * @type {boolean}
     * @memberof AssignmentReferencesDto
     */
    blocked: boolean;

    /**
     * Whether the caller created this assignment. When false, confirming deletes another practitioner’s work.
     *
     * @type {boolean}
     * @memberof AssignmentReferencesDto
     */
    own: boolean;

    /**
     * The assignment’s events, bucketed by what a delete costs
     *
     * @type {AssignmentReferencesCountsDto}
     * @memberof AssignmentReferencesDto
     */
    events: AssignmentReferencesCountsDto;

    /**
     * Scheduled date of the earliest attempted session (ISO 8601), or null when the member never trained on this therapy
     *
     * @type {string}
     * @memberof AssignmentReferencesDto
     */
    firstPerformedAt: string | null;

    /**
     * Scheduled date of the latest attempted session (ISO 8601)
     *
     * @type {string}
     * @memberof AssignmentReferencesDto
     */
    lastPerformedAt: string | null;
}

/**
 * @export
 * @enum {string}
 */
export enum AssignmentReferencesDtoStatusEnum {
    SCHEDULED = 'SCHEDULED',
    RESCHEDULED = 'RESCHEDULED',
    INPROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    DELAYED = 'DELAYED',
    MISSED = 'MISSED',
    NOTCOMPLETED = 'NOT_COMPLETED',
    SKIPPED = 'SKIPPED',
    DELETED = 'DELETED'
}

